import React, { Component } from "react";
import Functions from "../../src/functions";
import TreeMenu from "react-simple-tree-menu";
import Manager from "../../src/manager";

class Tree extends Component {
  state = {
    treeData: [],
    loading: true,
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    this.editable = this.editable.bind(this);
    this.nonEditable = this.nonEditable.bind(this);
    this.customUI = this.customUI.bind(this);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = "";
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    this.state = {
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
    };
  }

  componentDidMount() {
    const treeData = Functions.clone(
      this.props.property.configuration.treeData
    );
    this.enrichTreeData(treeData);
    this.setState({ loading: false, treeData: treeData });
    this.setState({
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      loaded: true,
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,
      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  editable() {
    let control = (
      <input
        type="text"
        defaultValue={this.state.defaultValue}
        placeholder={this.state.placeholder}
        name={this.state.name}
        {...this.state.attributes}
        {...this.state.events}
      ></input>
    );

    return this.customUI(control);
  }

  nonEditable() {
    let control = this.state.defaultValue;

    return this.customUI(control);
  }
  enrichTreeData(node) {
    var attributes = {};

    if (this.props.property.attributes) {
      attributes = this.props.property.attributes;
    }

    node.map((item, index) => {
      item.parentRef = attributes["data-parent-ref"];
      item.currentRef = attributes["data-current-ref"];
      item.primaryKeyValue = attributes["data-primaryKeyValue"];
      item.widgetModuleRef = attributes["data-widget-module-ref"];
      item.data = this.props.data;

      if (item.module) {
        if (item.module.module) {
          if (item.module.params) {
            item.module.params = this.createNewParams(item.module.params);
          }
        }
      }

      if (item.nodes) {
        if (item.nodes.length > 0) {
          this.enrichTreeData(item.nodes);
        }
      }
    });
  }

  createNewParams(_params) {
    let _newparams = {};

    if (typeof _params !== "undefined") {
      Object.keys(_params).map((property, propertyKey) => {
        _newparams[property] = {};

        Object.keys(_params[property]).map((item, itemKey) => {
          _newparams[property][item] = _params[property][item];

          if (typeof _params[property][item] === "string") {
            let paramsItemValue = _params[property][item];

            if (typeof this.props.parentdata !== "undefined") {
              Object.keys(this.props.parentdata).map(
                (dataItem, dataItemKey) => {
                  paramsItemValue = paramsItemValue.replace(
                    "parentdata[" + dataItem + "]",
                    this.props.parentdata[dataItem]
                  );
                }
              );
            }

            Object.keys(this.props.data).map((dataItem, dataItemKey) => {
              paramsItemValue = paramsItemValue.replace(
                "data[" + dataItem + "]",
                this.props.data[dataItem]
              );
            });

            _newparams[property][item] = paramsItemValue;
          }
        });
      });
    }

    return _newparams;
  }

  render() {
    var attributes = {};

    if (this.props.property.attributes) {
      attributes = this.props.property.attributes;
    }

    let data = this.props.data;

    if (this.state.loading) {
      return "Loading";
    } else {
      return (
        <TreeMenu
          data={this.state.treeData}
          debounceTime={125}
          disableKeyboard={false}
          hasSearch
          onClickItem={this.onClickItem}
          resetOpenNodesOnDataUpdate={false}
        />
      );
    }
    return "";
  }
}

export default Tree;
